import roadmapIllustration from '../../../assets/images/illustrations/restitution/roadmap.png';
import { useState } from 'react';
import { useToast } from '@/components/layout/Toast';
import { useProjectContext } from '@/providers/ProjectContextProvider';
import {
  RoadmapScreenDocument,
  useCreateRoadmapMutation,
} from '@/graphql/generated';
import { Loader } from '@/components/generic/Loader';
import { useTranslation } from '@/hooks/useTranslation';

export function CreateRoadmap({ readOnly }: { readOnly?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="p-8 flex flex-col gap-4 w-full items-center justify-center bg-blue-50 h-full">
      <img src={roadmapIllustration} alt="" className="w-56 grayscale" />
      <h1>{t('roadmap.create.empty')}</h1>
      {!readOnly && (
        <>
          <p className="max-w-2xl text-center">{t('roadmap.create.help')}</p>
          <CreateRoadmapButton />
        </>
      )}
    </div>
  );
}

export function CreateRoadmapButton() {
  const { t } = useTranslation();
  const toast = useToast();
  const projectContext = useProjectContext();
  const [createRoadmap] = useCreateRoadmapMutation();
  const [isLoading, setIsLoading] = useState(false);
  const companyId = useProjectContext()?.enterprise?.id;
  const create = () => {
    setIsLoading(true);
    createRoadmap({
      variables: {
        input: {
          company: {
            id: companyId || '',
          },
        },
      },
      refetchQueries: [
        {
          query: RoadmapScreenDocument,
          variables: {
            companyId: companyId!,
          },
        },
      ],
    })
      .then(() => {
        toast.openToastWithMessage(t('toast:roadmap.create.success'));
        projectContext?.refreshEnterprise();
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <button className="primary" onClick={create} disabled={isLoading}>
      {isLoading && <Loader />}
      <span>{t('roadmap.create.action')}</span>
    </button>
  );
}
